/**
 * Состояние источника в конкретном прогоне аудита.
 *
 * Отсутствующий источник всегда NOT_CONNECTED и трактуется как «не оценивалось»:
 * никогда не 0 и никогда не max, иначе метрика начинает поощрять
 * неподключение источников.
 */
export var ContextAuditSourceState;
(function (ContextAuditSourceState) {
    ContextAuditSourceState["CONTRIBUTED"] = "contributed";
    ContextAuditSourceState["CONNECTED_NO_DATA"] = "connected_no_data";
    ContextAuditSourceState["NOT_CONNECTED"] = "not_connected";
})(ContextAuditSourceState || (ContextAuditSourceState = {}));
//# sourceMappingURL=context-audit-source-state.enum.js.map